export const reminderRulesSeed = Array.from({ length: 10 }, (_, i) => ({
  id: `rr-${i}`,
  name: `Rule ${i + 1}: ${['Morning digest', 'T-15 reminder', 'D-1 notice'][i % 3]}`,
  appliesTo: ['all', 'internal', 'external'][i % 3],
  channels: [['email'], ['teams'], ['whatsapp', 'email']][i % 3],
  timingMinutes: [5, 15, 30, 60, 1440][i % 5],
  status: i % 6 === 0 ? 'disabled' : 'enabled',
  priority: (i % 5) + 1,
  meetingTypeFilter: ['all', 'client', 'internal', 'video_only'][i % 4],
  department: i % 7 === 0 ? 'Sales' : null,
  hasConflict: i % 8 === 3,
  conflictHint: i % 8 === 3 ? 'Overlaps with Rule 2 on same channel' : null,
}));

export const notificationLogsSeed = Array.from({ length: 45 }, (_, i) => ({
  id: `nl-${6000 + i}`,
  sentAt: new Date(Date.now() - i * 240000).toISOString(),
  meetingId: `mtg-${3000 + (i % 20)}`,
  meetingTitle: `Meeting ${(i % 20) + 1}`,
  recipient: `user${i % 15}@acme.example`,
  channel: ['Email', 'Teams', 'WhatsApp'][i % 3],
  type: ['Reminder', 'MOM ready', 'Booking confirm'][i % 3],
  status: ['delivered', 'failed', 'pending', 'retrying'][i % 11 === 0 ? 1 : i % 4],
  payloadPreview: JSON.stringify({ to: `user${i}@…`, templateId: 'ctpl-0' }).slice(0, 80),
  providerResponse: i % 11 === 0 ? 'Error 429: rate limited — full body…' : '200 OK',
  attempts: [
    { at: new Date(Date.now() - i * 240000 - 60000).toISOString(), result: 'failed', detail: 'timeout' },
    { at: new Date(Date.now() - i * 240000).toISOString(), result: i % 11 === 0 ? 'failed' : 'ok', detail: i % 11 === 0 ? '429' : 'sent' },
  ],
}));

export const escalationRulesSeed = Array.from({ length: 6 }, (_, i) => ({
  id: `er-${i}`,
  trigger: ['WhatsApp fails', 'Email fails', 'Teams fails'][i % 3],
  conditionAttempts: 2 + (i % 4),
  fallbackAction: ['Send Email', 'Send SMS', 'Notify Admin'][i % 3],
  delayMinutes: [5, 15, 30][i % 3],
  status: i % 5 === 0 ? 'disabled' : 'enabled',
}));
